const imageData = [
    {
        src: "/Assets/GalleryImages/88.webp",
        title: "Roller Blinds",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/16-1.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/35-1.webp",
        title: "Roller Blinds",
        keywords: "Roller Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/56.webp",
        title: "Sierra Blinds",
        keywords: "Sierra Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/87.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/17.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/36.webp",
        title: "Roller Blinds",
        keywords: "Roller Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/57.webp",
        title: "Sierra Blinds",
        keywords: "Sierra Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/86.webp",
        title: "Wooden Venetian Blinds",
        keywords: "Wooden Venetian Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/79.webp",
        title: "Wooden Venetian Blinds",
        keywords: "Wooden Venetian Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/37.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/58.webp",
        title: "Panel Blinds",
        keywords: "Panel Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/85.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Lounge Area",
    },
    {
        src: "/Assets/GalleryImages/19.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/38.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/60.webp",
        title: "Skylight Blinds",
        keywords: "Colby Blinds, Skylight Colby Blinds, Bathroom",
    },
    {
        src: "/Assets/GalleryImages/84.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/20.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/39.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/61.webp",
        title: "Wooden Venetian",
        keywords: "Wooden Venetian Blinds, Bathroom",
    },
    {
        src: "/Assets/GalleryImages/83.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/21-1.webp",
        title: "Aric Blinds",
        keywords: "Aric Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/40.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/62.webp",
        title: "Wooden Venetian",
        keywords: "Wooden Venetian Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/82.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/22.webp",
        title: "Aric Blinds",
        keywords: "Aric Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/41.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/63.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/81.webp",
        title: "Roman Blinds",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/23.webp",
        title: "Aric Blinds",
        keywords: "Aric Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/42.webp",
        title: "Meliso Blinds",
        keywords: "Meliso Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/64.webp",
        title: "Roman Printed",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/80.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/24-1.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/43.webp",
        title: "Meliso Blinds",
        keywords: "Meliso Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/65.webp",
        title: "Roller Blinds",
        keywords: "Roller Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/01.webp",
        title: "Sierra Blinds",
        keywords: "Sierra Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/25.webp",
        title: "Wooden Venetian Blinds",
        keywords: "Wooden Venetian Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/44.webp",
        title: "Patricia Blinds",
        keywords: "Patricia Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/05.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/02.webp",
        title: "Panel Blinds",
        keywords: "Panel Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/26.webp",
        title: "Wooden Venetian Blinds",
        keywords: "Wooden Venetian Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/45.webp",
        title: "Patricia Blinds",
        keywords: "Patricia Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/67.webp",
        title: "Roman Printed",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/06-5.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/27.webp",
        title: "Eton Blinds",
        keywords: "Eton Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/46.webp",
        title: "Patricia Blinds",
        keywords: "Patricia Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/68.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/07.webp",
        title: "Eton Blinds",
        keywords: "Eton Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/28.webp",
        title: "Meliso Blinds",
        keywords: "Meliso Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/47.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/69.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/08.webp",
        title: "Sierra Blinds",
        keywords: "Sierra Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/29.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/48.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/70.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Kitchen",
    },
    {
        src: "/Assets/GalleryImages/09.webp",
        title: "Sierra Blinds",
        keywords: "Sierra Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/30.webp",
        title: "Wooden Venetian Blinds",
        keywords: "Wooden Venetian Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/49-1.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, , Children room",
    },
    {
        src: "/Assets/GalleryImages/71.webp",
        title: "Roller Plain",
        keywords: "Roller Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/10.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, , Lounge Area",
    },
    {
        src: "/Assets/GalleryImages/31.webp",
        title: "Meliso Blinds",
        keywords: "Meliso Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/50.webp",
        title: "Skylight Blinds",
        keywords: "Colby Blinds, Skylight Colby Blinds, , Lounge Area",
    },
    {
        src: "/Assets/GalleryImages/72.webp",
        title: "Roller Screen",
        keywords: "Roller Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/11.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/32.webp",
        title: "Dorren Blinds, Bedroom",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/51.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Kitchen",
    },
    {
        src: "/Assets/GalleryImages/73.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/12.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/33.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/52.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/74.webp",
        title: "Roller Blinds",
        keywords: "Roller Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/13.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/34.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Kitchen",
    },
    {
        src: "/Assets/GalleryImages/53.webp",
        title: "Roman Blinds",
        keywords: "Roman Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/75.webp",
        title: "Roller Plain",
        keywords: "Roller Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/14.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Bedroom",
    },
    {
        src: "/Assets/GalleryImages/",
        title: "",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/54.webp",
        title: "Eton Blinds",
        keywords: "Eton Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/76.webp",
        title: "Colby Blinds",
        keywords: "Colby Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/15.webp",
        title: "Grayson Blinds",
        keywords: "Grayson Blinds, Living Room",
    },
    {
        src: "/Assets/GalleryImages/",
        title: "",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/55.webp",
        title: "Vertical Blinds",
        keywords: "Vertical Blinds, Office",
    },
    {
        src: "/Assets/GalleryImages/77.webp",
        title: "Roller Printed",
        keywords: "Roller Blinds, Dinning Room",
    },
    {
        src: "/Assets/GalleryImages/",
        title: "",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/",
        title: "",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/",
        title: "",
        keywords: "",
    },
    {
        src: "/Assets/GalleryImages/78.webp",
        title: "Luzon Blinds",
        keywords: "Luzon Blinds, Living Room",
    },

];

export default imageData;



